<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Box" class="d-icon d-icon--box" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 .501a1.5 1.5 0 0 0-.749.2l-3.5 2H1.75A1.5 1.5 0 0 0 1 4v4a1.5 1.5 0 0 0 .75 1.298l.002.001 3.498 1.999a1.5 1.5 0 0 0 1.5 0l3.498-1.999.002-.001A1.5 1.5 0 0 0 11 8V4a1.5 1.5 0 0 0-.75-1.298l-3.5-2h-.001A1.5 1.5 0 0 0 6 .5Zm-.25 1.067a.5.5 0 0 1 .5 0L9.49 3.42 6 5.423 2.51 3.42l3.238-1.85.002-.002ZM2 8a.5.5 0 0 0 .25.431L5.5 10.29v-4L2 4.28V8Zm7.933.25a.503.503 0 0 1-.183.182L6.5 10.289v-4L10 4.28V8a.5.5 0 0 1-.067.25Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconBox',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
